import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UploadWizardService } from '../wizard.service';
import { NewStoryService } from '../../new/new.service';
import { filter, find } from 'lodash';
import { FirebaseService } from 'app/services/firebase.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'upload-wizard-cover',
  styleUrls: ['../wizard.component.scss', './cover.component.scss'],
  templateUrl: './cover.component.html',
})
export class UploadWizardCoverComponent {
  @Input() step;
  @Input() totalSteps;
  @Input() isMobile;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  displayValidationModal;
  selectedPhotos = [];

  constructor(
    public uploadWizardService: UploadWizardService,
    public newStoryService: NewStoryService,
    private firebaseService: FirebaseService,
    private router: Router
  ) {
    this.selectedPhotos = this.getSelectedPhotos();
  }

  getTitle() {
    return this.isAutomaticMode()
      ? 'add_title_and_choose_cover'
      : 'add_title_and_subtitle';
  }

  getAvailablePhotos() {
    return filter(this.newStoryService.images, photo => {
      return !photo.unchecked;
    });
  }

  getSelectedPhotos() {
    return filter(this.newStoryService.images, 'frontcover');
  }

  selectedPhotosCount() {
    return this.getSelectedPhotos().length;
  }

  handleSelectedPhotosCount() {
    if (this.selectedPhotos.length < 1) {
      return;
    }

    this.newStoryService.images.forEach(item => {
      item.frontcover = !!find(this.selectedPhotos, selected => {
        return this.areFilesEqual(selected, item);
      });
    });
  }

  areFilesEqual(first, second) {
    return (
      first.name === second.name
    );
  }

  togglePhoto(photo) {
    photo.frontcover = !photo.frontcover;
    if (photo.frontcover) {
      this.selectedPhotos = [...this.selectedPhotos, photo].slice(-1);
      this.handleSelectedPhotosCount();
      this.firebaseService.logEvent('design_request_cover_images_select', {
        project_id: this.newStoryService.projectId
      });
    } else {
      this.selectedPhotos = filter(this.selectedPhotos, selected => {
        return !this.areFilesEqual(photo, selected);
      });
    }
  }

  isSelected(photo) {
    return photo.frontcover;
  }

  isCoverValid() {
    return this.selectedPhotosCount() && this.selectedPhotosCount() < 2;
  }

  isTitleValid() {
    const title = this.uploadWizardService.details.title;
    return title && title.trim().length;
  }

  isAutomaticMode() {
    return this.uploadWizardService.details.design_mode === 'automatic';
  }

  validate() {
    if (
      (this.isCoverValid() || !this.isAutomaticMode()) &&
      this.isTitleValid()
    ) {
      this.firebaseService.logEvent('design_request_title_select', {
        project_id : this.newStoryService.projectId,
        mode : this.uploadWizardService.details.design_mode,
        title : this.uploadWizardService.details.title,
      });
      this.next.emit();
    } else {
      this.displayValidationModal = true;
    }
  }

  hideModal() {
    this.displayValidationModal = false;
  }
  navigateBack() {
    this.router.navigate(['/stories/new']);
  }
}
